import { Config } from "../landing-config";
import { ico_pink } from "../map-config";


const maxFileRows = 500;
export const DARK_FIBER_CONFIG: Config = {
    data: {
        route: 'dark-fiber',
        page_title: 'Dark Fiber | Open Fiber',
        service_title: 'Dark Fiber',
        service_description: '',
        service_name: '',
        service_slug: 'darkfiber',
        errorTimeout: 0,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziodarkfiber/massivep2p/detail',
                massiveUploadPath: '/serviziodarkfiber/massivep2p/upload',
                massiveDownloadPath: '/serviziodarkfiber/data/massive/import.xlsx',
                massiveDownloadPath_2p: '/serviziodarkfiber/data/massive/import.xlsx', //Currently, it does not provide for a massive import of multiple points
                massiveP2pSalesforcePath: '/serviziodarkfiber/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/serviziodarkfiber/p2p',
			bboxPath: '/marketing/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: 'DARK_FIBER'
    },
    multiple_points: {
        variable: true,
        max: 3,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: true,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
				city_building: false,
				city_pfs: false,
				city_roe: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
				punti_intermedi: false,
				rete: false,
                pop_pcn_xpop: false,
            },
            a_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: true,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: true,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
				city_building: false,
				city_pfs: false,
				city_roe: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
				punti_intermedi: false,
				rete: false,
                pop_pcn_xpop: false,
            }
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['click', 'zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: true,
        marker_default_icon: ico_pink,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: true,
        id_bts_noa: false,
        id_bts_building: false,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAB', 'CoveredCD', 'CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pcn: {
        load: true,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: true,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: false,
        click: false,
        x_pop: true,
        is_registered: true,
        custom_research_method: 'Address',
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: true,
        click: true,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: false,
        click: false,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: false,
        types: null
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}